var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('h1',[_vm._v("404 NotFound")]),_c('p',[_vm._v("请配置路由")])])
}]

export { render, staticRenderFns }